export const ContactsUsage = Object.freeze({
  SAVED_CONTACTS: 'saved_contacts',
  VALID_EMAILS: 'valid_emails',
  VERIFICATIONS: 'verifications',
});
